import React from 'react'
import PropTypes from 'prop-types'
import Cell from '../Cell/Cell'
import styles from './IconCell.module.sass'
import { Link } from 'react-router-dom'
import printerSVG from './icons/printer.svg'
import calendarSVG from './icons/calendar.svg'
import trashSVG from './icons/trash.svg'
import pencilSVG from './icons/pencil.svg'


IconCell.propTypes = {
  iconName: PropTypes.oneOf(['printer', 'calendar', 'trash','pencil']),
  to: PropTypes.string,
  onClick: PropTypes.func
}
IconCell.defaultProps = {
  iconName: 'printer',
  onClick: () => {}
}

function IconCell({ iconName, onClick, to }) {

  const iconsSet = {
    printer: printerSVG,
    calendar: calendarSVG,
    trash: trashSVG,
	pencil: pencilSVG
  }
  const sizes = {
    printer: 16,
    calendar: 30,
    trash: 18,
    pencil: 16
  }


  return (
    <>
      {to
        ?
        <Link to={to}>
          <div className={styles.IconCell} onClick={onClick}>
            <img className={styles.img}
                 src={iconsSet[iconName]} alt='print' />
          </div>
        </Link>
        :
        <div className={styles.IconCell} onClick={onClick}>
          <img className={styles.img} style={{maxWidth: `${sizes[iconName]}px`}} src={iconsSet[iconName]} alt='print' />
        </div>
      }

    </>
  )
}

export default IconCell
